import FloatingFooter from './floating-footer';

export default FloatingFooter;
